class Xhr {
  /**
   * Create an instance of the class
   */
  constructor () {
    this.client = this._clientInstance();
    this.enableDefaults = true;

    this.defaults = {
      headers: {}
    };

    // load the client interceptors
    this._interceptors();
  }

  /**
   * Set the base URI
   *
   * @param {String} baseUri
   */
  setBaseUri (baseUri) {
    this.defaults.baseURL = baseUri;
  }

  /**
   * Set the default request headers to apply to each request
   *
   * @param {Array} headers
   * @param {String} type
   */
  setDefaultHeaders (headers, type = 'common') {
    // we do not leverage the client's default header behavior due to
    // its behavior of directly affecting its prototype causing hard
    // to identify and undesired side-affects as of v0.17.1
    this.defaults.headers[type] = headers;
  }

  /**
   * Get back the Xhr instance with common default configurations disabled
   *
   * @return {this}
   */
  get noDefaults () {
    const inst = Object.create(this);
    inst.enableDefaults = false;

    return inst;
  }

  /**
   * Make an HTTP request
   *
   * @param {String} method HTTP verb
   * @param {String} uri
   * @param {Object} data Request body
   * @param {Object} params Query parameters
   */
  request (method, uri, data, params) {
    return this.client({
      method: method,
      url: uri,
      data: data,
      params: params
    });
  }

  /**
   * Register client interceptors
   *
   * @return {Object}
   */
  _interceptors () {
    // This interceptor provides a flexible way of injecting default
    // Xhr client behavior without directly modifying the client's
    // prototype as of Axios v0.17.1
    this.client.interceptors.request.use((request) => {
      if (this.enableDefaults) {
        Object.assign(request, this.defaults);
      }

      return request;
    });
  }

  /**
   * Get an instance of the XHR client
   *
   * @return {Object}
   */
  _clientInstance () {
    return require('axios');
  }
}

['get', 'delete'].forEach(function (method) {
  /**
   * @param  {String} uri
   * @param  {Object} params Query parameters
   */
  Xhr.prototype[method] = function (uri, params) {
    return this.request(method, uri, null, params);
  };
});

['post', 'put', 'patch'].forEach(function (method) {
  /**
   * @param {String} uri
   * @param {Object} data Request body
   * @param {Object} params Query parameters
   */
  Xhr.prototype[method] = function (uri, data, params) {
    return this.request(method, uri, data, params);
  };
});

module.exports = Xhr;
